import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { NETWORK_LIST_COLUMN_LABEL_I18N_KEY } from '../network-list/network-list.config';
import { useNetworkListContext } from '../network.context';

export const NetworkListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useNetworkListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={NETWORK_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
